<div class="coworking-home-spaces-container">
  <div class="title">
    <h2>{{ "coworking-home.spaces.title" | translate }}</h2>
    <img [src]="getEditIcon" (click)="editSpaces()" />
  </div>
  <div class="spaces">
    <cowing-card *ngFor="let space of allSpaces" [space]="space"></cowing-card>
  </div>
  <div class="services">
    <div class="essentials">
      <h2>{{ "coworking-home.spaces.essentials" | translate }}</h2>
      <div class="essentials-container">
        <cowing-essential-service
          *ngFor="let service of essentialsServices"
          [isForm]="false"
          [label]="service.label"
          [icon_url]="service.icon_url"
        ></cowing-essential-service>
      </div>
    </div>
    <div class="others">
      <div class="inline">
        <h2>{{ "coworking-home.spaces.others" | translate }}</h2>
        <img [src]="getEditIcon" (click)="editServices()" />
      </div>
      <div>
        <span *ngFor="let services of othersServices; let i = index">
          {{
            i !== othersServices.length - 1
              ? services.label + ", "
              : services.label
          }}
        </span>
      </div>
    </div>
  </div>
  <div class="disclaimer">
    <img [src]="getInfoIcon" />
    <p>{{ "coworking-home.spaces.disclaimer" | translate }}</p>
  </div>
</div>
